var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container px-4 md:px-8 my-16 md:my-32"},[_c(_vm.component,{tag:"component",attrs:{"fields":_vm.fields,"default-options":_vm.defaultOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }